import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export interface CustomTooltipProps {
  children: React.ReactNode
  content: string
  contentClassName?: string
}

export const CustomTooltip = ({ children, content, contentClassName }: CustomTooltipProps) => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger>{children}</TooltipTrigger>
        <TooltipContent className={cn(contentClassName)}>{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default CustomTooltip
